import React from "react";

const TopicTabs = ({ topics, value, onChange }) => {
  const all = [{ slug: "all", label: "All" }, ...topics];
  return (
    <div className="flex flex-wrap gap-2">
      {all.map((t) => {
        const active = value === t.slug;
        return (
          <button
            key={t.slug}
            onClick={() => onChange(t.slug)}
            className={`ht-btn rounded-full px-4 py-1.5 text-sm border transition-colors ${
              active
                ? "bg-[#3d6486] border-[#3d6486] text-white"
                : "bg-white border-[#e6eef5] text-[#3d6486] hover:border-[#cfe7f8]"
            }`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
};

export default TopicTabs;
